export default __webpack_public_path__ + "c744ccdf2d0511d10a8bb0217da305c8.webp";